import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-graphicContent",
  "use": "icon-graphicContent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-graphicContent\"><path d=\"M759.921778 0H168.675556A111.729778 111.729778 0 0 0 56.888889 111.502222V764.017778C56.888889 907.491556 173.909333 1024 317.610667 1024h591.246222a111.729778 111.729778 0 0 0 111.786667-111.502222V259.982222C1020.814222 116.679111 903.793778 0 759.921778 0zM566.101333 698.936889H325.575111a49.095111 49.095111 0 1 1 0-98.304H566.044444a49.095111 49.095111 0 1 1 0 98.304z m185.912889-281.998222H325.575111a49.095111 49.095111 0 1 1 0-98.076445h426.439111a49.095111 49.095111 0 1 1 0 98.076445z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/graphicContent.svg
// module id = aKLK
// module chunks = 78